import React from "react";
import Image, { ImageProps } from "next/image";

interface ImageWithFallbackProps extends ImageProps {
  fallBackImageClassName?: string;
}

const ImageWithFallback = (props: ImageWithFallbackProps) => {
  const { fallBackImageClassName, src, alt, ...rest } = props;
  const placeholderSrc = "/placeholder-900x600.webp";

  const isFallback = typeof src === "string" && (src.trim() === "" || src.includes("no_image"));
  const srcDisplay = isFallback ? placeholderSrc : src;

  const imageClasses = isFallback
    ? `${fallBackImageClassName || ""} object-contain`
    : `max-h-[120px] object-contain md:max-h-[166px] ${rest.className || ""}`;

  return <Image loading="lazy" {...rest} alt={alt} src={srcDisplay} className={imageClasses} />;
};

export default ImageWithFallback;
